import { Component, Input } from '@angular/core';
import { TabularList } from '@portal/app/shared/models/IList';

@Component({
  selector: 'portal-tabular-list',
  templateUrl: './tabular-list.component.html',
  styleUrls: ['./tabular-list.component.scss'],
  standalone: false
})
export class TabularListComponent {
  @Input() public data!: TabularList[][];
}
